export default __webpack_public_path__ + "static/media/fondo-como-usar-mi-plan.49525452.png";